<i18n lang="json">{
  "ru": {
    "Как открыть вклад": "Как открыть вклад",
    "Заполните анкету": "Заполните анкету",
    "Наши специалисты помогут подобрать вклад и назначат время встречи": "Наши специалисты помогут подобрать вклад и назначат время встречи",
    "Фамилия, имя и отчество*": "Фамилия, имя и отчество*",
    "Мобильный телефон*": "Мобильный телефон*",
    "Электронная почта": "Электронная почта",
    "Заполняя форму, я принимаю": "Заполняя форму, я принимаю",
    "условия передачи информации": "условия передачи информации",
    "Подать заявку": "Подать заявку",
    "Или приходите в офис": "Или приходите в офис",
    "Адреса отделений и банкоматов Амра-Банка на карте": "Адреса отделений и банкоматов Амра-Банка на карте",
    "график работы, телефоны": "график работы, телефоны",
    "Онлайн": "Онлайн",
    "В офисе": "В офисе",
    "Офисы и банкоматы": "Офисы и банкоматы",
    "Перейти": "Перейти",
    "submitApplicationMobile": "Подать заявку",
    "applicationAccepted": "Заявка принята!",
    "Фото разворота паспорта" : "Фото разворота паспорта",
    "Фото страницы с пропиской" : "Фото страницы с пропиской",
    "Сохраняемый": "Сохраняемый",
    "Пополняемый": "Пополняемый"
  },
    "ab": {
    "Как открыть вклад": "Адепозит шаарттәу",
    "Фамилия, имя и отчество*": "Ажәла, ахьӡ, абхьӡ*",
    "Заполните анкету": "Азҵаабӷьыц хашәырҭәаа",
    "Мобильный телефон*": "Амобилтә ҭел.*",
    "Электронная почта": "Аелектронтә ҧошьҭа",
    "Заполняя форму, я принимаю": "Аформа харҭәаауа, сара исыдыскылоит аинформациа",
    "условия передачи информации": "аҭаратә еиқәышаҳаҭра",
    "Подать заявку": "Аҳәара аҭара",
    "Адреса отделений и банкоматов Амра-Банка на карте": "Амра-банк аҟәшақәеи абанкоматқәеи радресқәа ахсаалаҿы",
    "график работы, телефоны": "аусура аамҭа, аҭел аномерқәа",
    "Онлайн": "Аонлаин",
    "В офисе": "Аусбарҭаҿы",
    "Офисы и банкоматы": "Аусбарҭақәеи абанкоматқәеи",
    "Перейти": "Аиасра",
    "submitApplicationMobile": "Аҳәара аҭара",
    "applicationAccepted": "Заявка принята!",
    "Фото разворота паспорта" : "Атәылауаҩшәҟәы еиҵыхны асахьа",
    "Фото страницы с пропиской" : "Анхара ҭып адаҟьа асахьа",
    "Сохраняемый": "Ихьчоу",
    
    "Наши специалисты помогут подобрать вклад и назначат время встречи": "Наши специалисты помогут подобрать вклад и назначат время встречи",
    "Или приходите в офис": "Мамзаргьы аусбарҭахь шәааи",
    
    
    "Пополняемый": "Иузхарҭәаауа"

  },
  "en": {
    "Как открыть вклад": "How to open a deposit",
    "Заполните анкету": "Fill out the form",
    "Наши специалисты помогут подобрать вклад и назначат время встречи": "Our specialists will help you choose a deposit and schedule a meeting",
    "Фамилия, имя и отчество*": "Last name, first name and patronymic*",
    "Мобильный телефон*": "Mobile phone*",
    "Электронная почта": "Email",
    "Заполняя форму, я принимаю": "By filling out the form, I accept",
    "условия передачи информации": "the terms of information transfer",
    "Подать заявку": "Submit application",
    "Или приходите в офис": "Or visit the office",
    "Адреса отделений и банкоматов Амра-Банка на карте": "Addresses of Amra Bank branches and ATMs on the map",
    "график работы, телефоны": "working hours, phone numbers",
    "Онлайн": "Online",
    "В офисе": "In the office",
    "Офисы и банкоматы": "Offices and ATMs",
    "Перейти": "Go",
    "submitApplicationMobile": "Submit application",
    "applicationAccepted": "Application Accepted!",
       "Фото разворота паспорта": "Photo of passport spread",
    "Фото страницы с пропиской": "Photo of registration page",
       "Сохраняемый": "Fixed-term",
    "Пополняемый": "Replenishable"
  },
  "tr": {
    "Как открыть вклад": "Mevduat nasıl açılır",
    "Заполните анкету": "Formu doldurun",
    "Наши специалисты помогут подобрать вклад и назначат время встречи": "Uzmanlarımız size mevduat seçmenize yardımcı olacak ve bir görüşme ayarlayacak",
    "Фамилия, имя и отчество*": "Soyadı, adı ve baba adı*",
    "Мобильный телефон*": "Cep telefonu*",
    "Электронная почта": "E-posta",
    "Заполняя форму, я принимаю": "Formu doldurarak kabul ediyorum",
    "условия передачи информации": "bilgi aktarım koşulları",
    "Подать заявку": "Başvuruyu gönder",
    "Или приходите в офис": "Veya ofise gelin",
    "Адреса отделений и банкоматов Амра-Банка на карте": "Amra Bank şubeleri ve ATM'lerinin adresleri haritada",
    "график работы, телефоны": "çalışma saatleri, telefon numaraları",
    "Онлайн": "Çevrimiçi",
    "В офисе": "Ofiste",
    "Офисы и банкоматы": "Ofisler ve ATM'ler",
    "Перейти": "Git",
    "submitApplicationMobile": "Başvuruyu gönder",
    "applicationAccepted": "Başvuru Alındı!",
    "Фото разворота паспорта": "Pasaport açılış sayfasının fotoğrafı",
    "Фото страницы с пропиской": "İkamet sayfasının fotoğrafı",
     "Сохраняемый": "Sabit vadeli",
    "Пополняемый": "Eklenebilir"
  },
  "es": {
    "Как открыть вклад": "Cómo abrir un depósito",
    "Заполните анкету": "Rellena el formulario",
    "Наши специалисты помогут подобрать вклад и назначат время встречи": "Nuestros especialistas te ayudarán a elegir un depósito y programar una reunión",
    "Фамилия, имя и отчество*": "Apellido, nombre y segundo nombre*",
    "Мобильный телефон*": "Teléfono móvil*",
    "Электронная почта": "Correo electrónico",
    "Заполняя форму, я принимаю": "Al completar el formulario, acepto",
    "условия передачи информации": "los términos de transferencia de información",
    "Подать заявку": "Enviar solicitud",
    "Или приходите в офис": "O visita la oficina",
    "Онлайн": "En línea",
    "В офисе": "En la oficina",
    "Офисы и банкоматы": "Oficinas y cajeros automáticos",
    "Адреса отделений и банкоматов Амра-Банка на карте": "Direcciones de las sucursales y cajeros automáticos de Amra Bank en el mapa",
    "график работы, телефоны": "horario de trabajo, números de teléfono",
    "Перейти": "Ir",
    "submitApplicationMobile": "Enviar solicitud",
    "applicationAccepted": "¡Solicitud Aceptada!",
    "Фото разворота паспорта": "Foto de la doble página del pasaporte",
    "Фото страницы с пропиской": "Foto de la página con el registro de residencia",
        "Сохраняемый": "A plazo fijo",
    "Пополняемый": "Reintegrable"
  },
  "ar": {
    "Как открыть вклад": "كيفية فتح وديعة",
    "Заполните анкету": "املأ النموذج",
    "Наши специалисты помогут подобрать вклад и назначат время встречи": "سيقوم أخصائيو الاستشارات لدينا بمساعدتك في اختيار الوديعة وتحديد موعد الاجتماع",
    "Фамилия, имя и отчество*": "الاسم الأخير، الاسم الأول واسم الأب*",
    "Мобильный телефон*": "الهاتف المحمول*",
    "Электронная почта": "البريد الإلكتروني",
    "Заполняя форму, я принимаю": "بملء النموذج أقبل",
    "условия передачи информации": "شروط نقل المعلومات",
    "Подать заявку": "إرسال الطلب",
    "Или приходите в офис": "أو تعال إلى المكتب",
    "Адреса отделений и банкоматов Амра-Банка на карте": "عناوين فروع وأجهزة الصراف الآلي لبنك عمرا على الخريطة",
    "график работы, телефоны": "ساعات العمل، أرقام الهاتف",
    "Онлайн": "عبر الإنترنت",
    "В офисе": "في المكتب",
    "Офисы и банкоматы": "المكاتب وأجهزة الصراف الآلي",
    "Перейти": "اذهب",
    "submitApplicationMobile": "تقديم الطلب",
    "applicationAccepted": "تم قبول الطلب!",
     "Фото разворота паспорта": "صورة صفحة جواز السفر المفتوحة",
    "Фото страницы с пропиской": "صورة صفحة العنوان المسجل",
      "Сохраняемый": "ثابت الأجل",
    "Пополняемый": "قابل للتغذية"
  }
}</i18n>
<template>
  <section class="container mt-6 lg:mt-[60px] mb-5 lg:mb-8" id="deposits">
    <p class="text-xl font-firasans lg:text-4xl px-4 xl:px-0">
       {{ t("Как открыть вклад") }}  <!--<span class="hidden lg:inline-block">{{ t(depositType) }}</span> -->
    </p>
    <div class="hidden lg:block">
      <div class="grid grid-cols-10 gap-[30px] mt-7 h-109">
        <div
          class="overflow-hidden col-start-1 col-end-6 py-[20px] px-[14px] border-[1px] border-[#E1E1E1] rounded-2xl relative">
          <div v-if="!isSubmited">
            <p class="font-medium text-2xl">{{ t("Заполните анкету") }}</p>
            <p class="text-[#878787] mt-[10px]">
              {{
                t(
                  "Наши специалисты помогут подобрать вклад и назначат время встречи"
                )
              }}
            </p>
            <div class="grid grid-cols-2 gap-5 mt-[14px] relative">
              <div class="col-start-1 col-span-2">
                <AInput v-model="name" @blur="validator.name.$commit"  :isValid="!validator.name.$error" name="name"
                  class="rounded-xl md:rounded-3xl" styleInput="simple" height="large"
                  :placeholder="t('Фамилия, имя и отчество*')"></AInput>
              </div>
              <div class="col-start-1 col-span-1">
                <AInput v-model="phone" :isValid="!validator.phone.$error"  v-mask="'+# (###) ###-##-##'" @blur="validator.phone.$commit" name="phone"
                  class="rounded-xl md:rounded-3xl" styleInput="simple" height="large"
                  :placeholder="t('Мобильный телефон*')"></AInput>
              </div>
              <div class="col-start-2 col-span-1">
                <AInput v-model.trim="email" :isValid="!validator.email.$error" @blur="validator.email.$commit"
                  name="email" class="rounded-xl md:rounded-3xl" height="large" styleInput="simple"
                  :placeholder="t('Электронная почта')"></AInput>
              </div>
              <vue-uppy class="col-span-2 xs:col-span-1" v-model="passportPhoto"
                :placeholder="t('Фото разворота паспорта')" :is-valid="!validator.passportPhoto.$error" />
              <vue-uppy class="col-span-2 xs:col-span-1" v-model="registrationPhoto"
                :placeholder="t('Фото страницы с пропиской')" :is-valid="!validator.registrationPhoto.$error" />
            </div>
            <p class="mt-5 text-sm text-[#6F6F6F] font-sans">
              {{ t("Заполняя форму, я принимаю") }}
              <a href="#" class="underline !text-[#004BA3]">{{
                t("условия передачи информации")
              }}</a>
            </p>
            <AButton @click="onSubmit()" class="mt-[30px]" width="medium">{{
              t("Подать заявку")
            }}</AButton>
          </div>
          <div v-if="isSubmited" class="md:h-112 w-full flex flex-col lg:block relative px-0 xl:px-4">
            <div>
              <p class="text-4xl mb-3 font-firasans">
                {{ t("applicationAccepted") }}
              </p>
              <p class="text-sm md:text-lg mb-4 lg:mb-5 text-[#333333] font-sans">
                {{ t("Наши специалисты свяжутся с Вами в ближайшее время") }}
              </p>

              <AButton @click="resetForm" class="w-70 z-30 hidden lg:block" width="large">{{ t("Открыть еще вклад") }}
              </AButton>
            </div>

            <a-icon-application class="mx-auto block absolute -bottom-10 -right-10 w-90 h-80">0
            </a-icon-application>
            <div class="block lg:hidden w-full absolute bottom-0">
              <AButton @click="resetForm" width="mobile" class="block !w-full">{{ t("Открыть еще вклад") }}</AButton>
            </div>
          </div>
        </div>
        <div class="col-start-6 col-end-13 py-[30px] px-[26px] border-[1px] border-[#E1E1E1] rounded-2xl relative">
          <p class="text-3xl mb-[10px]">{{ t("Или приходите в офис") }}</p>
          <p class="text-[#878787] text-sm lg:text-base mb-[25px]">
            {{ t("Адреса отделений и банкоматов Амра-Банка на карте") }} —<br />
            {{ t("график работы, телефоны") }}.
          </p>
          <AMap name="desctopMap"></AMap>
          <nuxt-link :to="localePath('/offices')">
            <AButton type="map"
              class="!absolute right-10 bottom-10 text-lg !font-medium !w-68 lg:!w-36 hidden sm:block">
              {{ t("Перейти") }}</AButton>
          </nuxt-link>
        </div>
      </div>
    </div>
  </section>
  <div class="lg:hidden block">
    <div class="flex h-11 bg-[#F3F3F7]">
      <AButton :class="[activeTab === 'online' ? '!bg-darkYellow' : '']"
        class="!rounded-l-none !rounded-[10px] !h-11 w-full !bg-[#F3F3F7]" @click="onNavClick('online')">{{ t("Онлайн")
        }}
      </AButton>
      <AButton :class="[activeTab == 'office' ? '!bg-darkYellow' : '']"
        class="!rounded-r-none !rounded-[10px] !h-11 w-full !bg-[#F3F3F7]" @click="onNavClick('office')">{{ t("В офисе")
        }}
      </AButton>
    </div>
    <div>
      <div v-if="activeTab == 'online'" class="px-4 pb-6 xl:px-0 container">
        <div class="grid grid-cols-2 gap-5 mt-[14px] relative">
          <div class="col-span-2">
            <AInput v-model="name" @blur="validator.name.$commit" :isValid="!validator.name.$error" name="name"
              class="rounded-xl md:rounded-3xl" styleInput="simple" height="large"
              :placeholder="t('Фамилия, имя и отчество*')"></AInput>
          </div>
          <div class="col-span-2 xs:col-span-1">
            <AInput v-model="phone" :isValid="!validator.phone.$error" @blur="validator.phone.$commit"
              v-mask="'+# (###) ###-##-##'" name="phone" class="rounded-xl md:rounded-3xl" styleInput="simple"
              height="large" :placeholder="t('+7 (')"></AInput>
          </div>
          <div class="col-span-2 xs:col-span-1">
            <AInput v-model="email" :isValid="!validator.email.$error" @blur="validator.email.$commit" name="email"
              class="rounded-xl md:rounded-3xl" height="large" styleInput="simple" :placeholder="t('Email')"></AInput>
          </div>
          <vue-uppy class="col-span-2 xs:col-span-1" v-model="passportPhoto" :placeholder="t('Фото разворота паспорта')"
            :is-valid="!validator.passportPhoto.$error" />
          <vue-uppy class="col-span-2 xs:col-span-1" v-model="registrationPhoto"
            :placeholder="t('Фото страницы с пропиской')" :is-valid="!validator.registrationPhoto.$error" />
        </div>
        <p class="mt-5 text-sm text-[#6F6F6F] font-sans">
          {{ t("Заполняя форму, я принимаю") }}
          <a href="#" class="underline !text-[#004BA3]">{{
            t("условия передачи информации")
          }}</a>
        </p>
        <div class="!w-full">
          <AButton @click="onSubmit()" class="mt-[30px] !w-full xl:hidden block" width="mobile">{{ t("Подать заявку") }}
          </AButton>
        </div>
      </div>
      <div v-if="activeTab === 'office'" class="rounded-2xl pt-6 pb-6 relative px-4 container grid">
        <p class="text-xl lg:text-3xl mb-[10px]">
          {{ t("Офисы и банкоматы") }}
        </p>
        <p class="text-[#878787] text-sm lg:text-base mb-[25px]">
          {{ t("Адреса отделений и банкоматов Амра-Банка на карте") }}
        </p>
        <div class="relative w-full">
          <AMap name="mobileMap"></AMap>
        </div>
        <div class="px-3">
          <nuxt-link :to="localePath('/offices')" class="">
            <AButton width="mobile"
              class="bottom-16 absolute opacity-85 text-lg !font-medium  block max-w-98 !border-none">
              {{ t("Перейти") }}
            </AButton>
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const localePath = useLocalePath();
import { ref } from "vue";
import { useVuelidate } from "@vuelidate/core";
import {
  required,
  minLength,
  maxLength,
  email as emailValidator,
} from "@vuelidate/validators";
import { defineProps } from "vue";

const { $get, $post } = useAxios();

const props = defineProps({
  depositType: {
    type: String,
    required: true,
  },
  depositAmount: {
    type: Number,
    required: true,
  },
  currency: {
    type: String,
    required: true,
  },
  termOfDeposit: {
    type: Number,
    required: true,
  },
});

const name = ref("");
const phone = ref("");
const email = ref("");
const passportPhoto = ref(null);
const registrationPhoto = ref(null);
const isSubmited = ref(false);

const rules = reactive({
  name: {
    required,
    minLength: minLength(1),
  },
  email: {
    required,
    emailValidator,
    minLength: minLength(3),
  },
  phone: {
    required,
    minLength: minLength(18),
    maxLength: maxLength(18),
  },
  passportPhoto: {
    required,
  },
  registrationPhoto: {
    required,
  },
});

watch(
  phone,
  (newValue) => {
    if (newValue && !newValue.startsWith("+7")) {
      phone.value = "+7" + newValue;
    }
    if (newValue.length > 18) {
      phone.value = newValue.slice(0, 18);
    }
  },
  { deep: true }
);

const validator = useVuelidate(
  rules,
  { name, email, phone, passportPhoto, registrationPhoto },
  { $rewardEarly: true }
);

const isSubmit = ref(false);

async function onSubmit() {
  isSubmit.value = true;
  try {
    const isValid = await validator.value.$validate();
    if (!isValid) {
      alert("Проверьте правильность введенных данных");
      isSubmit.value = false;
      return;
    }

    await $post("deposit-aplicatons", {
      termOfDeposit: props.termOfDeposit,
      depositAmount: props.depositAmount,
      currency: props.currency,
      depositType: props.depositType,
      phone: phone.value,
      name: name.value,
      email: email.value,
      passportPhoto: passportPhoto.value?.uploadURL,
      registrationPhoto: registrationPhoto.value?.uploadURL,
    });
    alert("Данные успешно сохранены");
    isSubmit.value = false;
    isSubmited.value = true;
  } catch (e) {
    isSubmit.value = false;
    alert("Возникла ошибка. Попробуйте позже");
    console.error(e);
  }
}

function resetForm() {
  isSubmited.value = false;
  name.value = "";
  email.value = "";
  phone.value = "";
  passportPhoto.value = null;
  registrationPhoto.value = null;
  validator.value.$reset();
}

const activeTab = ref("online");

function onNavClick(tab: string) {
  console.log("переключено", tab);
  activeTab.value = tab;
  console.log("активное", activeTab.value);
}
</script>

<style scoped>
.placeholder-whitespace-normal::placeholder {
  white-space: normal;
}
</style>
